export type TCustomFonts =
    | 'Playfair Display'
    | 'Roboto Slab'
    | 'Arvo'
    | 'Bree Serif'
    | 'Merriweather'
    | 'Lora'
    | 'Slabo'
    | 'Libre Baskerville'
    | 'Frank Ruhl Libre'
    | 'Spectral'
    | 'Oswald'
    | 'Raleway'
    | 'Open Sans'
    | 'Roboto'
    | 'Lato'
    | 'Montserrat'
    | 'Abel'
    | 'Quicksand'
    | 'Oxygen'
    | 'Nunito'
    | 'ProximaNova'
    | 'PT Sans'
    | 'PT Sans Narrow'
    | 'Dosis'
    | 'Josefin Sans'
    | 'Source Sans Pro'
    | 'Dancing Script'
    | 'Courgette'
    | 'Caveat'
    | 'Great Vibes'
    | 'Kaushan Script'
    | 'Satisfy'
    | 'Mrs Sheppards'
    | 'Knewave'
    | 'Lily Script One'
    | 'Parisienne'
    | 'Comfortaa'
    | 'Abril Fatface'
    | 'Lobster'
    | 'Concert One'
    | 'Elsie'
    | 'Corben'
    | 'Fugaz One'
    | 'Baloo'
    | 'Special Elite'
    | 'Cutive Mono'
    | 'Inconsolata'
    | 'Droid Serif'
    | 'Open Sans Condensed'
    | 'Cormorant Garamond'
    | 'Mr Dafoe'
    | 'Mr De Haviland'
    | 'Kristi'
    | 'Mrs Saint Delafield';

export type TTextTransform =
    | 'none'
    | 'capitalize'
    | 'uppercase'
    | 'lowercase'
    | 'initial'
    | 'inherit';

export type TScope = 'system' | 'builder';

export type TSize = 'sm' | 'md' | 'lg' | 'xl';

export type TExtendedSize = 'xs' | TSize;

export type TControlSize = Extract<TSize, 'sm' | 'md' | 'lg'>;

export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<
    T,
    Exclude<keyof T, Keys>
> &
    {
        [K in Keys]-?: Required<Pick<T, K>> &
            Partial<Pick<T, Exclude<Keys, K>>>;
    }[Keys];

export enum Alignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right'
}

export type TLayoutAlignment = 'start' | 'center' | 'end';

export type TDirection = 'up' | 'down' | 'left' | 'right';

export type CSSPixelValue = 0 | `${number}px` | 'auto';

export type CSSDimensionValue =
    | `${CSSPixelValue}`
    | `${CSSPixelValue} ${CSSPixelValue}`
    | `${CSSPixelValue} ${CSSPixelValue} ${CSSPixelValue}`
    | `${CSSPixelValue} ${CSSPixelValue} ${CSSPixelValue} ${CSSPixelValue}`;

export type ImageFit = 'cover' | 'contain';
